import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";

// layout
import Layout from "layout/Layout";
import SubLayout from "layout/SubLayout";

// components
import Button from "components/Button/Button";

// hooks
import useSave from "hooks/useSave";

// store
import { isMobileWidthAtom } from "store/ui/atom";

// utils
import { PAGE_LAYOUT, PAGE_LAYOUT_EN } from "utils/pageLayoutConstants";

// assets
import Banner05 from "assets/images/pc/img_banner05.png";

/**
 * @file 커리어 - 행사공지 상세 페이지
 * @author TW.Lee
 */
const PromotionDetail = () => {
  const { isSaved } = useSave();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [events, setEvents] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const isMobileWidth = useRecoilValue(isMobileWidthAtom);
  const { REACT_APP_API } = process.env;

  const targetStorage = localStorage.getItem("accessToken")
    ? localStorage
    : sessionStorage;
  const userRole = targetStorage.getItem("role");
  const employeeRole = targetStorage.getItem("Erole");

  useEffect(() => {
    axios({
      method: "get",
      url: `/posts/${location.state?.post.id}`,
    }).then((res) => {
      setEvents(res.data.result);
    });
  }, []);

  // 게시물 삭제
  const deleteEventPost = async (args) => {
    await axios.delete(`/posts/${args}`).then((res) => {
      navigate("/promotion", { replace: true });
    });
  };

  if (isMobileWidth) {
    return (
      <Layout subFixed="true">
        <SubLayout
          banner={Banner05}
          pageText={
            t("lang") === "EN"
              ? PAGE_LAYOUT.promotion
              : PAGE_LAYOUT_EN.promotion
          }
        >
          <Container>
            <HiringDetailMobileInner>
              <div className="detail-section">
                <div className="detail-title">
                  <DetailMobileTitle>{events?.title}</DetailMobileTitle>
                  <div className="detail-date">
                    <DetailMobileRegDtm>
                      <span className="detail-txt">{t("period")}</span>
                      <span>
                        {events?.start_date?.substr(0, 10)} ~{" "}
                        {events?.end_date?.substr(0, 10)}
                      </span>
                    </DetailMobileRegDtm>
                  </div>
                </div>
                <div className="detail-contents">
                  <div className="detail-img">
                    <img
                      src={
                        events?.posts_files
                          ? `${REACT_APP_API}/files/${events?.posts_files.id}`
                          : ""
                      }
                    />
                  </div>
                  <div>{events?.content}</div>
                </div>
                {userRole === "EMPLOYEE" && employeeRole === "ADMIN" && (
                  <div className="detail-config">
                    <ConfigMobileUpdate
                      onClick={() =>
                        navigate(
                          `/promotion/promotion-edit/${location.state?.post.id}`,
                          {
                            state: {
                              post: location.state?.post,
                              data: events,
                            },
                          }
                        )
                      }
                    >
                      {t("modify")}
                    </ConfigMobileUpdate>
                    <ConfigMobileRemove
                      onClick={() => {
                        const isDelete =
                          isSaved("해당 게시글을 삭제하시겠습니까?");
                        const getData = () => {
                          isDelete.then((result) => {
                            if (result === true) {
                              deleteEventPost(location.state?.post.id);
                            }
                          });
                        };
                        getData();
                      }}
                    >
                      {t("delete")}
                    </ConfigMobileRemove>
                  </div>
                )}
              </div>
              <div className="detail_btn">
                <Button
                  variant="secondaryHover"
                  onClick={() => navigate("/promotion", { replace: true })}
                >
                  {t("backtolist")}
                </Button>
                <span className="void-sec"></span>
                <Button
                  variant="primaryHover"
                  disabled={isSubmit}
                  onClick={() => {
                    events.web_site && window.open(events.web_site);
                  }}
                >
                  {t("viewdetail")}
                </Button>
              </div>
            </HiringDetailMobileInner>
          </Container>
        </SubLayout>
      </Layout>
    );
  } else {
    return (
      <Layout subFixed="true">
        <SubLayout
          banner={Banner05}
          pageText={
            t("lang") === "EN"
              ? PAGE_LAYOUT.promotion
              : PAGE_LAYOUT_EN.promotion
          }
        >
          <Container>
            <HiringDetailInner>
              <div className="detail-section">
                <div className="detail-title">
                  <DetailTitle>{events?.title}</DetailTitle>
                  <div className="detail-date">
                    <DetailRegDtm>
                      <span className="detail-txt">{t("period")}</span>
                      <span>
                        {events?.start_date?.substr(0, 10)} ~{" "}
                        {events?.end_date?.substr(0, 10)}
                      </span>
                    </DetailRegDtm>
                  </div>
                </div>
                <div className="detail-contents">
                  <div className="detail-img">
                    <img
                      src={
                        events?.posts_files
                          ? `${REACT_APP_API}/files/${events?.posts_files.id}`
                          : ""
                      }
                    />
                  </div>
                  <div>{events?.content}</div>
                </div>
                {userRole === "EMPLOYEE" && employeeRole === "ADMIN" && (
                  <div className="detail-config">
                    <ConfigUpdate
                      onClick={() =>
                        navigate(
                          `/promotion/promotion-edit/${location.state?.post.id}`,
                          {
                            state: {
                              post: location.state?.post,
                              data: events,
                            },
                          }
                        )
                      }
                    >
                      {t("modify")}
                    </ConfigUpdate>
                    <ConfigRemove
                      onClick={() => {
                        const isDelete =
                          isSaved("해당 게시글을 삭제하시겠습니까?");
                        const getData = () => {
                          isDelete.then((result) => {
                            if (result === true) {
                              deleteEventPost(location.state?.post.id);
                            }
                          });
                        };
                        getData();
                      }}
                    >
                      {t("delete")}
                    </ConfigRemove>
                  </div>
                )}
              </div>
              <div className="detail_btn">
                <Button
                  variant="secondaryHover"
                  onClick={() => navigate("/promotion", { replace: true })}
                >
                  {t("backtolist")}
                </Button>
                <span className="void-sec"></span>
                <Button
                  variant="primaryHover"
                  disabled={isSubmit}
                  onClick={() => {
                    events.web_site && window.open(events.web_site);
                  }}
                >
                  {t("viewdetail")}
                </Button>
              </div>
            </HiringDetailInner>
          </Container>
        </SubLayout>
      </Layout>
    );
  }
};

export default PromotionDetail;

const Container = styled.div`
  padding-bottom: 100px;
`;

const HiringDetailInner = styled.div`
  & .detail-section {
    margin: 60px 0;
    border-top: 1px solid #222;
    border-bottom: 1px solid #ddd;
  }

  & .detail-title {
    padding: 40px 30px;
    border-bottom: 1px solid #ddd;
  }

  & .detail-date {
    display: flex;

    & span {
      font-size: 16px;
      font-weight: normal;
    }
  }

  & .detail-txt {
    color: #b2b2b2;
    margin-right: 10px;
  }

  & .detail-contents {
    margin: 0 30px 120px 30px;
    font-size: 18px;
    font-weight: normal;
  }

  & .detail-img {
    margin: 40px 0;
    & img {
      width: 100%;
    }
  }

  & .detail-config {
    display: flex;
    justify-content: end;
    margin-bottom: 18px;
    margin-right: 30px;
  }

  & .detail_btn {
    width: 408px;
    margin: 0 auto;
    padding-bottom: 100px;
    display: flex;
    justify-content: center;

    & .void-sec {
      margin: 0 6px;
    }
  }
`;

const DetailTitle = styled.div`
  font-size: 26px;
  font-weight: bold;
  color: #000;
  margin: 12px 0 20px;
`;
const DetailRegDtm = styled.div`
  margin-right: 20px;
`;
const DetailDeadline = styled.div``;

const ConfigUpdate = styled.button`
  padding: 8px 12px;
  border: solid 1px #444;
  margin-right: 6px;
`;
const ConfigRemove = styled.button`
  padding: 8px 12px;
  border: solid 1px #444;
  background-color: #444;
  color: #fff;
`;

const HiringDetailMobileInner = styled.div`
  & .detail-section {
    margin: 40px 0;
    border-top: 1px solid #222;
    border-bottom: 1px solid #ddd;
  }

  & .detail-title {
    padding: 20px 0;
    border-bottom: 1px solid #ddd;
  }

  & .detail-date {
    display: flex;

    & span {
      font-size: 14px;
      font-weight: normal;
    }
  }

  & .detail-txt {
    color: #b2b2b2;
    margin-right: 10px;
  }

  & .detail-contents {
    margin: 0 0 120px 0;
    font-size: 14px;
    font-weight: normal;
  }

  & .detail-img {
    margin: 20px 0;
    & img {
      width: 100%;
    }
  }

  & .detail-config {
    display: flex;
    justify-content: end;
    margin-bottom: 18px;
  }

  & .detail_btn {
    margin: 0 auto;
    padding-bottom: 60px;
    display: flex;
    justify-content: center;

    & .void-sec {
      margin: 0 6px;
    }
  }
`;

const DetailMobileTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 8px 0 12px;
`;
const DetailMobileRegDtm = styled.div`
  margin-right: 20px;
`;
const DetailMobileDeadline = styled.div``;

const ConfigMobileUpdate = styled.button`
  padding: 8px 12px;
  border: solid 1px #444;
  margin-right: 6px;
  font-size: 14px;
`;
const ConfigMobileRemove = styled.button`
  padding: 8px 12px;
  border: solid 1px #444;
  background-color: #444;
  color: #fff;
  font-size: 14px;
`;
